import { Reveal } from "./Reveal";
import { Wrench, Building, Coins, GraduationCap } from "lucide-react";

const CATEGORIES = [
  { icon: Wrench, title: "Skills & Expertise", desc: "Developers, engineers, designers, legal and financial advisors — capability on demand." },
  { icon: Building, title: "Physical & Commercial Assets", desc: "Commercial yards, warehousing, industrial machinery, office and retail space." },
  { icon: Coins, title: "Capital & Opportunities", desc: "Seed funding, joint ventures, franchising and strategic partnerships." },
  { icon: GraduationCap, title: "Knowledge & Mentorship", desc: "Industry veterans, market-entry guidance and hard-won operational experience." },
];

export const ExplainSection = () => (
  <section id="exchange" data-testid="explain-section" className="relative py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="explain-eyebrow">
          /// THE EXCHANGE
        </span>
      </Reveal>

      <div className="mt-10 grid lg:grid-cols-2 gap-px bg-white/10 border border-white/10">
        <Reveal className="bg-[#05070B] p-10 lg:p-16">
          <h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100" data-testid="explain-need-title">
            What do you <span className="text-[#00F0FF]">need</span>?
          </h2>
          <p className="mt-6 text-slate-400 text-base sm:text-lg leading-relaxed">
            A yard. An investor. A developer. A route into a new market. Whatever is missing,
            someone in the network already has it.
          </p>
        </Reveal>
        <Reveal delay={0.12} className="bg-[#05070B] p-10 lg:p-16">
          <h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100" data-testid="explain-offer-title">
            What can you <span className="text-[#8A2BE2]">offer</span>?
          </h2>
          <p className="mt-6 text-slate-400 text-base sm:text-lg leading-relaxed">
            Skills, space, capital, knowledge, time. Whatever you hold, someone in the network
            is searching for it right now.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <p className="mt-14 max-w-3xl text-lg sm:text-xl text-slate-300 leading-relaxed" data-testid="explain-summary">
          FINDXCHANGE connects <span className="text-[#00F0FF]">people</span>, <span className="text-[#00F0FF]">businesses</span>,{" "}
          <span className="text-[#00F0FF]">skills</span>, <span className="text-[#00F0FF]">knowledge</span>,{" "}
          <span className="text-[#00F0FF]">resources</span> and <span className="text-[#00F0FF]">opportunities</span> —
          turning what you have into what someone else needs.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {CATEGORIES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08} className="h-full">
            <div className="card-frame h-full p-8 group" data-testid={`explain-card-${i}`}>
              <c.icon size={22} className="text-[#00F0FF] transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="mt-5 font-display font-bold text-lg text-slate-100 uppercase tracking-wide">{c.title}</h3>
              <p className="mt-3 text-sm text-slate-500 leading-relaxed">{c.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
